import React, { Suspense, useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { checkAuthentication } from 'utils/authUtils';
import NavbarPanel from 'components/template/Navbar';
import Sidebar from 'components/template/Sidebar';
import { LoadingScreen } from 'components/UI/common/atoms/Loading';
import ModalHakAkses from 'components/UI/common/molecules/ModalHakAkses';
import { useQuery, useQueryClient } from 'react-query';
import { getListCHat } from 'utils/purchasing/chat';
import { listenIncomingChat } from 'helper/socket';
import { withExtraMenus } from 'utils/common/sidebarMenu';

const CHAT_MENU_URL = '/chat/purchasing';
// icon boxicons (bx-message-rounded-dots), menggantikan icon chat dari database
const CHAT_MENU_ICON = 'message-rounded-dots';

const ChatMenuLabel = ({ label }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
    {label}
    <span
      style={{
        width: '8px',
        height: '8px',
        borderRadius: '9999px',
        backgroundColor: '#E53935',
        display: 'inline-block',
      }}
    />
  </span>
);

const RootTemplate = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleExpandedSidebar = () => {
    setIsExpanded((prev) => !prev);
  };
  const [showModalAkses, setShowModalAkses] = useState(false);
  const sidebarMenu = withExtraMenus(
    JSON.parse(localStorage.getItem('sideMenu'))
  );
  const isAuthenticated = checkAuthentication();
  const queryClient = useQueryClient();

  // dot merah di menu chat jika ada chat aktif yang belum dibaca
  const hasChatMenu = Boolean(
    isAuthenticated && sidebarMenu?.some((menu) => menu?.url === CHAT_MENU_URL)
  );
  const { data: dataListChat } = useQuery(['fetchListChat'], () => getListCHat(), {
    enabled: hasChatMenu,
    refetchInterval: 60000,
  });
  const hasUnreadChat = Boolean(
    dataListChat?.data?.chat_room?.some((room) => room?.unread_message > 0)
  );

  useEffect(() => {
    if (!hasChatMenu) return;
    return listenIncomingChat(() => {
      queryClient.invalidateQueries('fetchListChat');
      queryClient.invalidateQueries('fetchListChatHistory');
    });
  }, [hasChatMenu]);

  const routes = [];

  const routesMenu = sidebarMenu?.map((menu) => (
    {
      isSub: menu?.childs?.length > 0,
      icon: menu?.url === CHAT_MENU_URL ? CHAT_MENU_ICON : menu?.icon || '',
      path: menu?.url || '',
      label:
        menu?.url === CHAT_MENU_URL && hasUnreadChat
          ? <ChatMenuLabel label={menu?.name} />
          : menu?.name || '',
      childs: menu?.childs?.map((child) => ({
        path: child?.url || '',
        label: child?.name || '',
      }))
    }));
  routes.push(routesMenu);

  const { pathname } = useLocation();
  const exceptionUrlFinance = '/administrasi/finance/pengaturan/profil';
  const exceptionUrlAdmin = '/pengaturan/admin/profil';
  const exceptionUrlCFO = '/pengaturan/cfo/profil';
  const exceptionUrlPurchasing = '/pengaturan/purchasing/profil';

  useEffect(() => {
    if (
      !sidebarMenu?.find((e) => e.url === pathname || (e.childs?.find((child) => pathname.includes(child.url)))) &&
      pathname !== exceptionUrlFinance && pathname !== exceptionUrlAdmin && pathname !== exceptionUrlCFO && pathname !== exceptionUrlPurchasing
    ) {
      if (isAuthenticated) {
        setShowModalAkses(true);
      }
    }
  }, [sidebarMenu, pathname]);

  return (
    <div className="flex h-screen ">
      <Sidebar
        routes={routes}
        logo="../Logo.png"
        isExpanded={isExpanded}
        handleExpandedSidebar={handleExpandedSidebar}
      />

      <div className="flex-1 flex flex-col overflow-hidden ">
        <NavbarPanel handleMenu={handleExpandedSidebar} />
        <Suspense fallback={<LoadingScreen />}>
          <div className="overflow-y-auto flex-1">
            <Outlet />
          </div>
        </Suspense>
      </div>

      <ModalHakAkses
        isShow={Boolean(showModalAkses)}
        handleIsShow={() => setShowModalAkses(!showModalAkses)}
      />
    </div>
  );
};

export default RootTemplate;
